import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ShareCardTileThumbnailsQueryVariables = Types.Exact<{
  filter: Types.StationeryTemplateFilter;
}>;

export type ShareCardTileThumbnailsQuery = {
  __typename?: 'Query';
  stationeryTemplatesContainer: {
    __typename?: 'StationeryTemplateContainer';
    pagedResults: {
      __typename?: 'StationeryTemplateConnection';
      edges: Array<{ __typename?: 'StationeryTemplateEdge'; node: { __typename?: 'StationeryTemplate'; id: string; thumbnailUrl?: string | null } }>;
    };
  };
};

export const ShareCardTileThumbnailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShareCardTileThumbnails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTemplateFilter' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryTemplatesContainer' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filter' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagedResults' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'IntValue', value: '12' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShareCardTileThumbnailsQuery__
 *
 * To run a query within a React component, call `useShareCardTileThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareCardTileThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareCardTileThumbnailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useShareCardTileThumbnailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShareCardTileThumbnailsQuery, ShareCardTileThumbnailsQueryVariables>) {
  return ApolloReactHooks.useQuery<ShareCardTileThumbnailsQuery, ShareCardTileThumbnailsQueryVariables>(ShareCardTileThumbnailsDocument, baseOptions);
}
export function useShareCardTileThumbnailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShareCardTileThumbnailsQuery, ShareCardTileThumbnailsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ShareCardTileThumbnailsQuery, ShareCardTileThumbnailsQueryVariables>(ShareCardTileThumbnailsDocument, baseOptions);
}
export type ShareCardTileThumbnailsQueryHookResult = ReturnType<typeof useShareCardTileThumbnailsQuery>;
export type ShareCardTileThumbnailsLazyQueryHookResult = ReturnType<typeof useShareCardTileThumbnailsLazyQuery>;
export type ShareCardTileThumbnailsQueryResult = Apollo.QueryResult<ShareCardTileThumbnailsQuery, ShareCardTileThumbnailsQueryVariables>;
